const isDevelopment = import.meta.env.DEV

function write(level, args, developmentOnly = false) {
  if (developmentOnly && !isDevelopment) return

  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return
  }

  window.dispatchEvent(new CustomEvent('x3algo:log', {
    detail: {
      level,
      args,
      timestamp: new Date().toISOString()
    }
  }))
}

const logger = {
  debug: (...args) => write('debug', args, true),
  info: (...args) => write('info', args, true),
  warn: (...args) => write('warn', args),
  error: (...args) => write('error', args)
}

export default logger
